// Single source of truth for the "welcome back" intro-step copy (ticket [C]).
// Product/marketing edit copy here — never inline in StepWelcomeBack.jsx.
// `brandedName` is interpolated at render; falls back to a neutral word when a
// tenant has no Company#branded_name set.
export const buildWelcomeBackContent = (brandedName) => ({
  headline: `Welcome back to the refreshed ${brandedName || 'platform'}`,
  subheadline:
    "A lot has changed since you were last here. Let's make sure your goals " +
    'are up to date so you get the most out of the new experience.',
  benefits: [
    'Cleaner design, improved navigation, and built-in guidance for a more intuitive experience',
    'The ability to review and update your motivation, goals, and timeline in one short flow',
    'Keep your succession plan accurate as priorities shift',
    'Easier planning, evaluation of options, and confident decision-making',
  ],
  // Shown only when an approval workflow is actually enabled on the company
  // (seller_approval_process / successor_approval_process) — gated by the caller.
  fyi:
    'Note: Changes to your goals may need a quick review from your manager ' +
    "before they go live. We'll keep you posted.",
  cta: "Let's go",
});

export default buildWelcomeBackContent;
